/* eslint-disable max-lines-per-function */
import React, { useState, useRef } from 'react';
import Popup from 'reactjs-popup';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import './styles.css';
import { Formik } from 'formik';
import * as yup from 'yup';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Messages } from 'primereact/messages';
import { insereAceite } from '../../services/assinaturas/index';
import FundoAmarelo from '../../assets/fundo_amarelo.png';
import {
    showWarn,
    showError,
    showSuccess
} from '../../modulos/messages';
import apiZelo from '../../services/backAxiosVendaToken';
import { DialogErroBlacklistAceite } from '../dialogs/dialog-erro-blacklist';
import { Growl } from 'primereact/growl';

import AceiteEletronicoForm from './aceiteEletronicoForm';
import { validaTelefone } from './validaTelefone';

const AceiEl = props => {
    const inscricao = props.inscricao.toString();
    const adesaoPaga = props.adesaoPaga;
    const { tipoCob } = props;

    const [loading, setLoading] = useState('loading');
    const [sucesso, setSucesso] = useState(false);
    const [dialogBlacklist, setDialogBlacklist] = useState(false);
    const [celularInvalido, setCelularInvalido] = useState(false);

    const validations = yup.object().shape({
        EmailEnvio: yup
            .string()
            .email('Email não é válido')
            .when('FormaEnvio', {
                is: 2,
                then: yup.string().email().required().test(
                    '',
                    '@grupozelo.com não é um domínio permitido!',
                    (value, context) => !value.toLowerCase().includes('@grupozelo')
                ),
                otherwise: yup.string().email()
            }),
        TelefoneEnvio: yup
            .string()
            .when('FormaEnvio', {
                is: value => value === 1 || value === 3,
                then: yup.string().required().test(
                    '',
                    'celular inválido',
                    (value, context) => {
                        const celularFormatado = value.replace(/ |-|\(|\)/gi, '');

                        if (!Number(celularFormatado) || `${Number(celularFormatado)}`.length !== 11) {
                            setCelularInvalido(true);

                            return false;
                        }

                        if (!validaTelefone(celularFormatado)) {
                            setCelularInvalido(true);

                            return false;
                        }

                        setCelularInvalido(false);

                        return true;
                    }
                )
            })
    });
    const messages = useRef(null);
    const growl = useRef(null);

    const initialValues = {
        FormaEnvio: '',
        TipoAceite: '',
        EmailEnvio: props.email ? props.email : '',
        TelefoneEnvio: props.celular ? props.celular : ''
    };

    const checarCelular = async (celularFormatado, errors, setFieldError) => {
        const response = await apiZelo.get(`lista-negra/${celularFormatado}`);

        const arrayInscricoes = response.data?.inscricoes?.split(';');

        if (arrayInscricoes?.length >= 3) {
            setDialogBlacklist(true);
        }

        return true;
    };

    const handleSubmit = async values => {
        try {
            setLoading('nada');
            values.Inscricao = inscricao;

            if (!values.TipoAceite || !values.FormaEnvio) {
                showError(growl, 'Verifique se as opções \'forma de envio\' e \'Tipo de envio\' estão marcadas ');
                throw new Error('Verifique se as opções \'forma de envio\' e \'Tipo de envio\' estão marcadas ');
            }

            const response = await insereAceite(values);

            if (response.message !== 'sucessufuly') {
                throw new Error(response.message || 'Falha ao enviar o Aceite!');
            }

            showSuccess(growl, 'Aceite enviado');
            setTimeout(() => { window.location.reload(); }, 3000);
        } catch (error) {
            showWarn(growl, 'Falha ao enviar o Aceite');
            console.log(error.message);
        } finally {
            setLoading('loading');
        }
    };

    const header = <img alt="Card" src={FundoAmarelo} />;

    return (
        <>

            <Growl ref={growl} />

            <Popup
                className='popup'
                modal
                closable={true}
                trigger={
                    <Button
                        type="submit"
                        label="Aceite Eletrônico"
                        className="p-button-warning"
                        onClick={checarCelular}
                    />
                }
            >
                {close => (
                    <div className="modal">
                        <div className="content">
                            <Card header={header} title="Aceite do contrato">
                                <div style={{ display: 'inline-block' }} >
                                    <Messages className='messageContent' ref={messages} />
                                </div>
                                {loading == 'loading' && (
                                    <Formik
                                        initialTouched={{
                                            TelefoneEnvio: true,
                                            EmailEnvio: true
                                        }}
                                        onSubmit={handleSubmit}
                                        initialValues={initialValues}
                                        validationSchema={validations}
                                    >
                                        {() => (
                                            <AceiteEletronicoForm
                                                sucesso={sucesso}
                                                tipoCob={tipoCob}
                                                adesaoPaga={adesaoPaga}
                                                close={close}
                                                checarCelular={checarCelular}
                                                celularInvalido={celularInvalido}
                                            />
                                        )}
                                    </Formik>
                                )}
                                {loading != 'loading' && (
                                    <div className={loading}>
                                        <ProgressSpinner
                                            style={{
                                                width: '100px',
                                                height: '100px'
                                            }}
                                            strokeWidth="1"
                                            fill="#EEEEEE"
                                            animationDuration=".5s"
                                        />
                                    </div>
                                )}
                                <DialogErroBlacklistAceite
                                    visible={dialogBlacklist}
                                    openDialog={dialogBlacklist}
                                    messageHeader='Telefone suspeito!'
                                    closeDialog={() => setDialogBlacklist(false)}
                                />
                            </Card>
                        </div>
                    </div>
                )}
            </Popup>
        </>
    );
};

export default AceiEl;
